import "./App.css";
import { Routes } from "./HomePageMain/Navbar/Routes";

function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
